import { Injectable, signal } from '@angular/core';

/**
 * Global flag for "your session has expired" — set once by the HTTP interceptor on a 401,
 * consumed by the app root which shows a single centered modal. Centralising it here means a
 * 401 from ANY API call surfaces the same friendly popup instead of a silent redirect, and a
 * burst of concurrent 401s only ever shows one dialog.
 */
@Injectable({ providedIn: 'root' })
export class SessionExpiredService {
  /** True while the session-expired modal should be visible. */
  readonly expired = signal(false);

  /** Raise the session-expired state (idempotent — repeat calls while already shown are no-ops). */
  notifyExpired(): void {
    if (!this.expired()) {
      this.expired.set(true);
    }
  }

  /** Clear the state (after the user acknowledges and we redirect to login). */
  reset(): void {
    this.expired.set(false);
  }
}
